export default __webpack_public_path__ + "static/media/David-Van-Bruwaene.f8dd4b84.jpeg";